<template>
  <div
      ref="modal"
      tabindex="0"
      class="vac-media-preview"
      @click.stop="closeModal"
      @keydown.esc="closeModal"
  >
    <transition name="vac-bounce-preview" appear>
      <div v-if="isImage" class="vac-media-preview-container">
        <div v-if="loading" class="vac-image-loading">
          <div class="loading-spinner"></div>
        </div>
        <img
            v-show="!loading"
            class="vac-image-preview"
            :src="file.url"
            loading="eager"
            decoding="async"
            fetchpriority="high"
            alt="preview"
            @load="onImageLoad"
            @error="onImageError"
        />
      </div>

      <div v-else-if="isVideo" class="vac-media-preview-container">
        <video controls autoplay preload="metadata">
          <source :src="file.url" type="video/mp4"/>
        </video>
      </div>
    </transition>

    <div class="vac-svg-button">
      <slot name="preview-close-icon">
        <svg-icon name="close-outline" param="preview"/>
      </slot>
    </div>
  </div>
</template>
<script>
import SvgIcon from '@/modules/whatsapp/components/SvgIcon/SvgIcon.vue'

import {isImageFile, isVideoFile} from '@/modules/whatsapp/utils/media-file'

export default {
  name: 'MediaPreview',
  components: {
    SvgIcon
  },

  props: {
    file: {type: Object, required: true}
  },

  emits: ['close-media-preview'],

  data() {
    return {
      loading: true
    }
  },

  computed: {
    isImage() {
      return isImageFile(this.file)
    },
    isVideo() {
      return isVideoFile(this.file)
    }
  },

  watch: {
    file: {
      immediate: true,
      handler() {
        this.loading = true
      }
    }
  },

  mounted() {
    this.$refs.modal.focus()
  },

  methods: {
    closeModal() {
      this.$emit('close-media-preview')
    },
    onImageLoad() {
      this.loading = false
    },
    onImageError() {
      this.loading = false
    }
  }
}
</script>
